import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function unidade(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@unidade/ON_SELECT': {
        draft.data = action.payload.unidade;
        break;
      }
      case '@unidade/SIGN_IN_SUCCESS': {
        draft.data = { ...draft.data, ...action.payload.unidade };
        break;
      }
      case '@unidade/UNIDADE_LOAD_PERMISSIONS_SUCCESS': {
        draft.data = {
          ...draft.data,
          permissions: { ...action.payload.permissions },
        };
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
